import { render } from "./DefectCard.vue?vue&type=template&id=7efbcb9b"
import script from "./DefectCard.vue?vue&type=script&lang=js"
export * from "./DefectCard.vue?vue&type=script&lang=js"

import "./DefectCard.vue?vue&type=style&index=0&id=7efbcb9b&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QIcon from 'quasar/src/components/icon/QIcon.js';
import QCardActions from 'quasar/src/components/card/QCardActions.js';
import QBtn from 'quasar/src/components/btn/QBtn.js';
import qInstall from "../../node_modules/@quasar/app-webpack/lib/webpack/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QIcon,QCardActions,QBtn});
